/* Nordic Weaving: størrelsesvælger i krydssalget. Bygget 9/9-2026.

   PROBLEMET: temaets produktkort har en køb-knap der kun kan lægge i kurven
   når produktet har ÉN variant. Har det størrelser, sender den i stedet
   kunden til produktsiden. Næsten alle NW's lagner og pudebetræk har
   størrelser, så knappen i kurvens krydssalg førte i praksis VÆK fra kurven.
   En kunde der forlader kurven for at kigge på et lagen kommer ikke
   nødvendigvis tilbage.

   LØSNINGEN: en vælger og en Læg i kurv-knap direkte i kortet, så man vælger
   størrelse og lægger i uden at forlade kurven. Har produktet kun én
   variant, vises ingen vælger, kun knappen.

   ORDLYDEN, rettet 11/9-2026. Knappen hed "Tilføj", men skiftede undervejs
   til "Lægger i …" og "Lagt i kurven". Den brugte altså to forskellige
   udsagnsord inde i sit eget forløb. Samtidig sagde produktsiden "Tilføj til
   kurv" og kurven "Læg i kurv", så der var tre ordlyd for samme handling på
   tværs af sitet. Nu hedder den "Læg i kurv" alle tre steder. Målt er der
   149 px knapbredde mod 64 px tekst, så den lange form er der plads til.

   ALT HENTES LIVE fra /products/<handle>.js. Ingen håndskrevne
   størrelseslister. Det er samme regel som i søvnguiden, hvor en
   håndskreven lagertabel lovede størrelser der ikke fandtes, og varen faldt
   tavst ud af kurven. Udsolgte varianter kommer slet ikke i vælgeren.

   OBSERVER-DISCIPLIN, samme tre værn som nw-gem.js:
   1. Hvert kort bygges kun én gang, markeret på selve elementet.
   2. Observeren kobles fra mens vi skriver, så vi ikke vækker os selv.
   3. Én delegeret klik-lytter, ikke en pr. knap.
   Uden dem gentegnes kortene ved enhver ændring på siden, og så kan man
   ikke ramme knappen med et rigtigt klik. Det er målt før: 152 gentegninger
   på fire sekunder.
*/
(function (w, d) {
  'use strict';

  var cache    = {};
  var observer = null;
  var travl    = false;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ALTID TO DECIMALER, rettet 10/9-2026.
     Før stod der 449 kr på hele beløb og 449,00 kr på skæve. Målt i skuffen:
     det SAMME produkt stod med "Fra 449,00 kr" på temaets kort og "449 kr" i
     vores størrelsesvælger, i samme skærmbillede. To skrivemåder for det
     samme tal læses som to forskellige priser. Temaets money-filter skriver
     altid to decimaler, så det er dét format alt andet retter sig efter. */
  function kr(oere) {
    if (oere === null || oere === undefined || isNaN(oere)) return '';
    var v = oere / 100;
    return (Math.round(v * 100) / 100).toLocaleString('da-DK', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + ' kr';
  }

  function udenAtVaekkeOsSelv(fn) {
    if (observer) observer.disconnect();
    try { fn(); }
    finally {
      if (observer) {
        observer.takeRecords();
        observer.observe(d.documentElement, { childList: true, subtree: true });
      }
    }
  }

  /* Kun kort der ligger i kurvens krydssalg. Produktkort andre steder på
     sitet skal have temaets egen adfærd og må ikke røres. */
  function kortene() {
    return d.querySelectorAll(
      '.nwxs .product-block, cart-drawer .cart-item-upsells .product-block, .cart-drawer .cart-item-upsells .product-block'
    );
  }

  function handleFra(kort) {
    var a = kort.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var del = (a.getAttribute('href') || '').split('?')[0].split('/products/')[1];
    return del ? del.split('/')[0] : null;
  }

  function hentProdukt(handle) {
    if (cache[handle] !== undefined) return Promise.resolve(cache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (p) { cache[handle] = p; return p; });
  }

  function byg(kort) {
    if (kort._nwXs) return;
    var handle = handleFra(kort);
    if (!handle) return;
    kort._nwXs = true;

    hentProdukt(handle).then(function (p) {
      if (!p || !kort.isConnected) return;

      var ledige = p.variants.filter(function (v) { return v.available; });

      udenAtVaekkeOsSelv(function () {
        /* Temaets egen køb-knap skjules i stedet for at blive fjernet.
           Temaet kan finde på at gentegne kortet, og et element vi har
           slettet kommer tilbage, mens et vi har skjult bliver skjult. */
        kort.querySelectorAll('custom-quick-buy, .quick-buy-product-btn').forEach(function (e) {
          e.style.display = 'none';
        });

        var boks = d.createElement('div');
        boks.className = 'nwxs-add';

        if (!ledige.length) {
          boks.innerHTML = '<span class="nwxs-add__ud">Udsolgt</span>';
          kort.appendChild(boks);
          return;
        }

        var html = '';
        if (ledige.length > 1) {
          html += '<select class="nwxs-add__str" aria-label="Vælg størrelse til ' + esc(p.title) + '">';
          ledige.forEach(function (v) {
            html += '<option value="' + v.id + '">' + esc(v.title) + ' &middot; ' + kr(v.price) + '</option>';
          });
          html += '</select>';
        } else {
          /* Én variant: ingen vælger, men feltet skal stadig findes, så
             knappen kan læse den samme vej som ved flere størrelser. */
          html += '<input type="hidden" class="nwxs-add__str" value="' + ledige[0].id + '">';
        }
        html += '<button type="button" class="nwxs-add__btn">Læg i kurv</button>';

        boks.innerHTML = html;
        kort.appendChild(boks);
      });
    });
  }

  function opdaterKurv() {
    /* Skuffen henter kurven forfra på dette event. På kurvsiden lytter
       nw-kurv.js på det samme og genindlæser siden, fordi temaet ikke har
       nogen krog til at gentegne kurvsiden.

       DE 350 MS ER IKKE PYNT, tilføjet 10/9-2026. Mads meldte at skuffen
       LUKKEDE når han lagde et krydssalgsprodukt i kurven fra sin telefon.
       Jeg kunne ikke genskabe det med et programmatisk klik på computer, så
       det peger på berøringens egen rækkefølge: på iOS kan der gå et stykke
       tid fra touchend til det syntetiske click, og gentegner vi hele
       skuffen i det vindue, bliver knappen under fingeren skiftet ud midt i
       gestussen. Det er præcis den fælde vi har målt før i nw-gem.js: når et
       element udskiftes mellem tryk og slip, får det aldrig sit klik, og
       browseren sender klikket videre til en fælles forfader. Rammer det
       .js-overlay eller skuffen selv, kalder temaets SideDrawer.handleClick
       close() og skuffen lukker.

       Ved at vente til gestussen er helt forbi, gentegner vi aldrig noget
       under en finger der stadig er på skærmen. */
    setTimeout(function () {
      try {
        d.documentElement.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      } catch (e) {}
    }, 350);
  }

  /* EN FEJL SKAL SIGE NOGET, tilføjet 11/9-2026.

     Efterprøvet ved at lade /cart/add.js svare 422, som når en vare bliver
     udsolgt mellem at siden blev hentet og kunden trykker: knappen gik
     tilbage til sin egen tekst, og der skete INGENTING ellers. Ingen besked,
     varen kom bare ikke i kurven. Kunden har ingen måde at vide om hun
     ramte forkert, om nettet svigtede, eller om varen er væk.

     Shopify sender selv en forklaring i svaret, typisk i description, fx
     "Der er kun 2 tilbage". Den er bedre end noget jeg kan finde på, så vi
     viser den når den er der, og falder ellers tilbage på en neutral linje.

     Beskeden får farven #a3402f, den samme som "Udsolgt" bruger på
     favoritsiden, så rødt betyder det samme to steder. Stilen sættes her i
     stedet for i nw-xs.css, så rettelsen kun rører én fil. */
  function visFejl(boks, besked) {
    if (!boks) return;
    var p = boks.querySelector('.nwxs-add__fejl');
    if (!p) {
      p = d.createElement('p');
      p.className = 'nwxs-add__fejl';
      p.setAttribute('role', 'alert');
      p.style.cssText = 'margin:7px 0 0;font-size:12px;line-height:16px;color:#a3402f';
      boks.appendChild(p);
    }
    p.textContent = besked || 'Kunne ikke lægges i kurven. Prøv igen.';
  }

  function ryddFejl(boks) {
    var p = boks && boks.querySelector('.nwxs-add__fejl');
    if (p && p.parentNode) p.parentNode.removeChild(p);
  }

  function tilfoej(btn) {
    if (travl) return;
    var boks = btn.closest('.nwxs-add');
    var felt = boks && boks.querySelector('.nwxs-add__str');
    if (!felt || !felt.value) return;

    ryddFejl(boks);
    travl = true;
    btn.disabled = true;
    btn.textContent = 'Lægger i …';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(felt.value), quantity: 1 }] })
    })
      .then(function (r) {
        if (r.ok) return null;
        /* Svaret læses FØR vi kaster, ellers er kroppen tabt. */
        return r.json()
          .catch(function () { return null; })
          .then(function (j) {
            var fejl = new Error('add fejlede');
            fejl.besked = j && (j.description || j.message);
            throw fejl;
          });
      })
      .then(function () {
        travl = false;
        btn.textContent = 'Lagt i kurven';
        opdaterKurv();
      })
      .catch(function (fejl) {
        travl = false;
        btn.disabled = false;
        btn.textContent = 'Læg i kurv';
        visFejl(boks, fejl && fejl.besked);
      });
  }

  /* ---------- gemte varer hører ikke hjemme i krydssalget ----------

     MÅLT 10/9-2026: med et pudebetræk i kurven og et boxlagen gemt til senere
     stod "Bambus boxlagen Taupe" BÅDE under "Gør sættet færdigt" og under
     "Gemt til senere", på samme skærm, med fjorten centimeter imellem. Vi
     brugte altså en af fire pladser i krydssalget på at anbefale noget kunden
     allerede har markeret interesse for og selv har lagt til side. Det er
     spildt plads i skuffens dyreste område, og for kunden ligner det at
     butikken ikke kan huske hvad hun lige har gjort.

     KORTET FJERNES, DET SKJULES IKKE. Et kort med display:none tæller stadig
     som barn, og hele layoutet for ét, to og tre kort hviler på :has() og
     :nth-child(). Skjulte kort ville få tre synlige kort til at blive layoutet
     som fire. Fjernelse er childList og skal derfor pakkes ind i
     udenAtVaekkeOsSelv, ellers vækker vi vores egen observer.

     Kommer kortet igen fordi temaet gentegner krydssalget, fjerner vi det
     igen ved næste gennemløb. Fjerner kunden varen fra Gemt til senere, er
     der intet der fjerner kortet, og så dukker det op ved næste gentegning.
     Det er den rigtige rækkefølge: listen er sandheden, kortene retter sig
     efter den. */
  function erGemt(handle) {
    if (!w.NWWishlist || !handle) return false;
    var alle;
    try { alle = w.NWWishlist.all(); } catch (e) { return false; }
    if (!alle || !alle.length) return false;
    for (var i = 0; i < alle.length; i++) {
      if (alle[i] && alle[i].h === handle) return true;
    }
    return false;
  }

  function fjernGemte() {
    if (!w.NWWishlist) return;
    var doemte = [];
    kortene().forEach(function (kort) {
      var handle = handleFra(kort);
      if (handle && erGemt(handle)) doemte.push(kort);
    });
    if (!doemte.length) return;
    udenAtVaekkeOsSelv(function () {
      doemte.forEach(function (kort) {
        if (kort.parentNode) kort.parentNode.removeChild(kort);
      });
    });
  }

  function koer() {
    fjernGemte();
    kortene().forEach(byg);
  }

  var planlagt = null;
  function planlaeg() {
    if (planlagt) return;
    planlagt = setTimeout(function () { planlagt = null; koer(); }, 120);
  }

  function start() {
    koer();

    /* Én lytter på dokumentet, ikke en pr. knap. Kortene kommer og går, og
       lyttere sat pr. knap ville stable sig op og fyre flere gange for det
       samme klik.

       CAPTURE-FASEN og stopPropagation, tilføjet 10/9-2026. Knappen ligger
       INDE i skuffen, og temaets SideDrawer sætter sin egen klik-lytter på
       skuffen når den åbnes:
         handleClick(evt){ (evt.target.matches(".js-close-drawer") ||
                            evt.target === this.overlay) && this.close() }
       Et klik på vores knap skal aldrig nå så langt. Ved at fange i capture
       og standse videreførelsen er der kun én der behandler klikket, og
       ingen anden kode i temaet kan nå at reagere på det. Se også noten i
       opdaterKurv() om hvorfor gentegningen er udsat. */
    d.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.nwxs-add__btn') : null;
      if (!b || b.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      tilfoej(b);
    }, true);

    /* Gemmer kunden en vare mens skuffen er åben, skal kortet forsvinde med
       det samme. Uden dette ville det først ske ved næste gentegning. */
    try {
      var wlEvent = (w.NWWishlist && w.NWWishlist.EVENT) || 'nw:wishlist';
      d.addEventListener(wlEvent, planlaeg);
      d.documentElement.addEventListener(wlEvent, planlaeg);
      w.addEventListener(wlEvent, planlaeg);
    } catch (e) {}

    /* Krydssalget hentes asynkront og flyttes bagefter af nw-kurv.js, så
       kortene findes ikke ved sideindlæsning. */
    try {
      observer = new MutationObserver(planlaeg);
      observer.observe(d.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  d.readyState === 'loading' ? d.addEventListener('DOMContentLoaded', start) : start();
})(window, document);
